import { Component, Inject, OnInit } from '@angular/core';
import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';

@Component({
  selector: 'add-property-modal',
  templateUrl: './add-property-modal.html',
  styleUrls: ['./add-property-modal.scss']
})
export class AddPropertyModalComponent {
  public value: string = '';
  public name: string = '';
  public description: string = '';
  constructor(public modalComponentRef: BzgModalRef) { }

  close() {
    this.modalComponentRef.close();
  }
  ok() {
    const result = {
      name: this.name.trim(),
      default: this.value.trim(),
      description: this.description.trim()
    }
    this.modalComponentRef.close(result);
  }
  btnDisabled() {
    return this.name.trim().length === 0 || this.value.trim().length === 0 || this.description.trim().length === 0;
  }
}
